module.exports = __webpack_public_path__ + "img/italo.d32865f6.png";